import { i18nTranslationHelper } from '@/i18n'
import ClosedCaptionOffOutlinedIcon from '@mui/icons-material/ClosedCaptionOffOutlined'
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined'
import { IconProps, SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { UserContentDetailsLanguageFormat } from './user-content-details-model'

export namespace ContentLanguageFormatType {
  const t = i18nTranslationHelper.getTEnums
  export class Enum {
    static readonly LANGUAGE = new Enum(
      'LANGUAGE',
      t('contentLanguageFormat.LANGUAGE.title'),
      t('contentLanguageFormat.LANGUAGE.pluralTitle'),
      LanguageOutlinedIcon
    )

    static readonly CAPTION = new Enum(
      'CAPTION',
      t('contentLanguageFormat.CAPTION.title'),
      t('contentLanguageFormat.CAPTION.pluralTitle'),
      ClosedCaptionOffOutlinedIcon
    )

    public constructor(
      public readonly name: string,
      public readonly title: string,
      public readonly pluralTitle: string,
      public readonly icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>
    ) {}

    public get Icon() {
      return this.icon as React.ComponentType<IconProps>
    }
  }

  export const getByName = (name: string): Enum => {
    return Object.values(ContentLanguageFormatType.Enum).find(type => type.name === name)
  }

  export const filterFormats = (
    formats: UserContentDetailsLanguageFormat[],
    type: Enum
  ): UserContentDetailsLanguageFormat[] => {
    return formats.filter(f => f.type === type)
  }
}
